import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { AppleAirPlaySecurityPreset } from '@rocksoft/mdm-sdk-v2';

export type AirplaySecurityProfileState = EntityState<AppleAirPlaySecurityPreset>;

export function selectIdFromAirplaySecurityProfile(conf: AppleAirPlaySecurityPreset): string {
  return conf.uniqueId;
}

export const adapter: EntityAdapter<AppleAirPlaySecurityPreset> = createEntityAdapter<AppleAirPlaySecurityPreset>({
  selectId: selectIdFromAirplaySecurityProfile,
});

export const initialState: AirplaySecurityProfileState = adapter.getInitialState();
